var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"personal-header"},[_c('div',{staticClass:"bd"},[_c('div',{staticClass:"logo",attrs:{"title":"元气桌面"}}),_c('div',{staticClass:"r"},[_c('div',{staticClass:"download-tip"}),_c('a',{staticClass:"btn-download",attrs:{"href":_vm.transformProtocol(_vm.info.install_pkg),"rel":"noopener noreferrer"}},[_vm._v("点击下载")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }